import { render, staticRenderFns } from "./ImportacaoCatalogo.vue?vue&type=template&id=09209880"
import script from "./ImportacaoCatalogo.vue?vue&type=script&lang=ts"
export * from "./ImportacaoCatalogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports